
import XLSXStyle from "xlsx-style";
export default function exportExcel(array, name, merges) {
	name += new Date().toLocaleString()
	let workbook = window.XLSX.utils.book_new();
	let sheet = window.XLSX.utils.aoa_to_sheet(array);

	sheet['!merges'] = merges
	window.XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");
	window.XLSX.writeFile(workbook, name + '.xls'); //导出Excel
	// openDownloadDialog(sheet2blob(array), name + '.xls');
}

/**
 * 通用的打开下载对话框方法，没有测试过具体兼容性
 * @param url 下载地址，也可以是一个blob对象，必选
 * @param saveName 保存文件名，可选
 */
export function openDownloadDialog(url, saveName) {
	var urlA;
	if (typeof url === "object" && url instanceof Blob) {
		urlA = URL.createObjectURL(url); // 创建blob地址
	}
	const aLink = document.createElement("a");
	aLink.href = urlA;
	// HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
	aLink.download = saveName || "";
	let event;
	if (window.MouseEvent) event = new MouseEvent("click");
	else {
		event = document.createEvent("MouseEvents");
		event.initMouseEvent(
			"click",
			true,
			false,
			window,
			0,
			0,
			0,
			0,
			0,
			false,
			false,
			false,
			false,
			0,
			null
		);
	}
	aLink.dispatchEvent(event);
}
// 将一个sheet转成最终的excel文件的blob对象，然后利用URL.createObjectURL下载
export function sheet2blob(sheet, sheetName) {
	var sheetNameS = sheetName || "sheet1";
	var workbook = {
		SheetNames: [sheetNameS],
		Sheets: {},
	};
	workbook.Sheets[sheetNameS] = sheet;
	// 生成excel的配置项
	var wopts = {
		bookType: "xlsx", // 要生成的文件类型
		bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
		type: "binary",
	};
	var wbout = XLSXStyle.write(workbook, wopts);
	// XLSXStyle.write(wb, { bookType: bookType, bookSST: false, type: 'binary' });
	var blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
	// 字符串转ArrayBuffer
	function s2ab(s) {
		var buf = new ArrayBuffer(s.length);
		var view = new Uint8Array(buf);
		for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
		return buf;
	}
	return blob;
}